import React from 'react';
import PropTypes from 'prop-types';

import { Checkmark, X } from 'components/svg';
import { Image } from 'components/core/Image';
import { H1, Text, Paragraph } from 'components/core/Typography';
import { Button } from 'components/core/Button';
import { scrollToElement } from 'lib/helpers';
import Container from 'components/core/Page/Container';
import podsLogo from 'assets/images/brand/portable-storage/logo-pods.png';
import packRatLogo from 'assets/images/brand/portable-storage/logo-packRat.png';
import uPackLogo from 'assets/images/brand/portable-storage/logo-upack.png';

import './portableStorageComparison.scss';

export function PortableStorageComparison({ handleHowItWorks, isPSP, city }) {
	return (
		<Container className="comparison-chart">
			<H1
				className="chart-header"
				size="large"
				weight="medium"
			>
				{`Popular Portable storage options ${
					isPSP ? '' : `in ${city}`
				}`}
			</H1>
			<Paragraph className="chart-subheader">
				Not sure where to start looking for portable storage? SpareFoot
				is here to give you the inside scoop on three of the most
				popular portable storage brands and their services.{' '}
			</Paragraph>
			<table>
				<tbody>
					<tr>
						<th />
						<th>
							<Image
								src={podsLogo}
								className="static-testimonial-image"
								alt="pods Logo"
							/>
							{handleHowItWorks && (
								<Button
									link
									onClick={handleHowItWorks}
									rel="noreferrer noopener"
									className="comparison-link"
								>
									how it works
								</Button>
							)}
						</th>
						<th>
							<Image
								src={packRatLogo}
								className="static-testimonial-image packrat-logo"
								alt="packRat Logo"
							/>
							{handleHowItWorks && (
								<Button
									link
									onClick={handleHowItWorks}
									rel="noreferrer noopener"
									className="comparison-link"
								>
									how it works
								</Button>
							)}
						</th>
						<th>
							<Image
								src={uPackLogo}
								className="static-testimonial-image"
								alt="uPack Logo"
							/>
							{handleHowItWorks && (
								<Button
									link
									onClick={handleHowItWorks}
									rel="noreferrer noopener"
									className="comparison-link"
								>
									how it works
								</Button>
							)}
						</th>
					</tr>
					<tr>
						<td>
							<Text
								color="gray"
								size="small"
								weight="medium"
							>
								Storage
							</Text>
						</td>
						<td>
							<div className="icon-container">
								<Checkmark />
							</div>
						</td>
						<td>
							<div className="icon-container">
								<Checkmark />
							</div>
						</td>
						<td>
							<div className="icon-container">
								<X />
							</div>
						</td>
					</tr>
					<tr>
						<td>
							<Text
								color="gray"
								size="small"
								weight="medium"
							>
								Moving
							</Text>
						</td>
						<td>
							<div className="icon-container">
								<Checkmark />
							</div>
						</td>
						<td>
							<div className="icon-container">
								<Checkmark />
							</div>
						</td>
						<td>
							<div className="icon-container">
								<Checkmark />
							</div>
						</td>
					</tr>
					<tr>
						<td>
							<Text
								color="gray"
								size="small"
								weight="medium"
							>
								Local Moving
							</Text>
						</td>
						<td>
							<div className="icon-container">
								<Checkmark />
							</div>
						</td>
						<td>
							<div className="icon-container">
								<Checkmark />
							</div>
						</td>
						<td>
							<div className="icon-container">
								<X />
							</div>
						</td>
					</tr>
					<tr>
						<td>
							<Text
								color="gray"
								size="small"
								weight="medium"
							>
								Long Distance Moving
							</Text>
						</td>
						<td>
							<div className="icon-container">
								<Checkmark />
							</div>
						</td>
						<td>
							<div className="icon-container">
								<Checkmark />
							</div>
						</td>
						<td>
							<div className="icon-container">
								<Checkmark />
							</div>
						</td>
					</tr>
					<tr>
						<td>
							<Text
								color="gray"
								size="small"
								weight="medium"
							>
								Labor Available
							</Text>
						</td>
						<td>
							<div className="icon-container">
								<Checkmark />
							</div>
						</td>
						<td>
							<div className="icon-container">
								<Checkmark />
							</div>
						</td>
						<td>
							<div className="icon-container">
								<Checkmark />
							</div>
						</td>
					</tr>
					<tr>
						<td>
							<Text
								color="gray"
								size="small"
								weight="medium"
							>
								Street-legal containers
							</Text>
						</td>
						<td>
							<div className="icon-container">
								<Checkmark />
							</div>
						</td>
						<td>
							<div className="icon-container">
								<Checkmark />
							</div>
						</td>
						<td>
							<div className="icon-container">
								<Checkmark />
							</div>
						</td>
					</tr>
					<tr>
						<td>
							<Text
								color="gray"
								size="small"
								weight="medium"
							></Text>
						</td>
						<td>
							<Button
								href="https://www.pods.com/partners/sparefoot"
								target="_blank"
								rel="noopener noreferrer"
							>
								Choose PODS
							</Button>
						</td>
						<td>
							<Button
								href="https://www.1800packrat.com/?irclickid=R-RTqzWAsxyKR8EwyXTfu3VWUksRBNwFqWtjxQ0&utm_source=Impact&utm_medium=Affiliate&irgwc=1"
								target="_blank"
								rel="noopener noreferrer"
							>
								Choose Pack-Rat
							</Button>
						</td>
						<td>
							<Button
								href="https://www.kqzyfj.com/click-8367506-12188931"
								target="_blank"
								rel="noopener noreferrer"
							>
								Choose UPack
							</Button>
						</td>
					</tr>
				</tbody>
			</table>
		</Container>
	);
}

PortableStorageComparison.propTypes = {
	handleHowItWorks: PropTypes.func.isRequired,
	city: PropTypes.string.isRequired,
	isPSP: PropTypes.bool,
};

const EnhancedPortableStorageComparison = (props) => (
	<PortableStorageComparison
		{...props}
		handleHowItWorks={() => scrollToElement('#HowItWorks')}
	/>
);

export default EnhancedPortableStorageComparison;
